import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容分类',
    links: [
      { label: '娱乐八卦', href: '/category/yule-bagua' },
      { label: '网红黑料', href: '/category/wanghong-heiliao' },
      { label: '社会热点', href: '/category/shehui-redian' },
      { label: '综艺剧透', href: '/category/zongyi-jumu' },
      { label: '带货翻车', href: '/category/daihuo-fanchu' },
      { label: '吃瓜前线', href: '/category/chigua-qianxian' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '联系我们', href: '/about#contact' },
      { label: '用户协议', href: '#' },
      { label: '隐私政策', href: '#' },
      { label: '免责声明', href: '#' },
    ],
  },
  {
    title: '热门标签',
    links: [
      { label: '娱乐圈八卦', href: '/category/yule-bagua' },
      { label: '直播翻车', href: '/category/daihuo-fanchu' },
      { label: '网红人设崩塌', href: '/category/wanghong-heiliao' },
      { label: '综艺内幕', href: '/category/zongyi-jumu' },
      { label: '社会事件', href: '/category/shehui-redian' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-line text-white text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white whitespace-nowrap">
                黑料社区网
              </span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              专注热门爆料、娱乐八卦与网红内容的社区聚合平台。第一时间获取最新资讯，做最懂吃瓜的你。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-white transition-colors duration-200 cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-white transition-colors duration-200 cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-white transition-colors duration-200 cursor-pointer">
                <i className="ri-share-forward-line text-sm"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((column) => (
            <div key={column.title}>
              <h4 className="text-white font-semibold text-sm mb-4 font-heading">{column.title}</h4>
              <ul className="space-y-2">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 黑料社区网 Heiliao Community. All rights reserved.
          </p>
          <p className="text-xs text-background-400">
            本站内容来源于用户投稿与网络收集，不代表本站立场。如有侵权请联系删除。
          </p>
        </div>
      </div>
    </footer>
  );
}